<template>
  <div>
    <div class="filters-container">
      <filters-menu :filters="['lojas', 'data']" default-date="ultimosTrintaDias" hide-ecommerce-configuration />
    </div>

    <mf-loading v-if="loading" :boolean-loader="loading" loader-type="dynamic" :dynamic-amount="5" :dynamic-width="300" class="my-4" />

    <div v-else>
      <div class="extract-table">
        <template v-for="(item, index) in history">
          <div v-if="shouldShowYearMarker(item, index)" :key="`year-${index}`" class="year-marker">
            {{ getItemYear(item.date, item.type) }}
          </div>

          <div :key="`item-${index}`" class="extract-row">
            <div class="extract-left-section">
              <div class="extract-date-section">
                <div class="date-container">
                  <span class="date-text">{{ formatDate(item.date, item.type).weekDay }}</span>
                  <span class="date-separator hidden-xs-only">-</span>
                  <span class="date-text">{{ formatDate(item.date, item.type).date }}</span>
                </div>
                <span class="time-text hidden-sm-and-down">{{ formatTime(item.date, item.type) }}</span>
              </div>

              <div class="extract-description-section">
                <div class="description-title">{{ item.type }}</div>
                <div class="description-subtitle">
                  <span v-if="item.type === 'Ajuste' || item.type === 'Pontos expirados'" class="description-subtitle">Saldo atualizado</span>
                  <div v-else-if="item.type !== 'Compra sem pontos'">
                    <span v-if="item.unit" class="description-subtitle">Loja: {{ item.unit }}</span>
                    <span v-if="item.unit && item.total && item.type === 'Compra'" class="description-subtitle hidden-sm-and-down"> | </span>
                    <span v-if="item.total && item.type === 'Compra'" class="description-subtitle">Total da compra: {{ item.total }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="extract-right-section" :class="getBackgroundClass(item.type, item)">
              <div class="points-container">
                <div v-if="item.type === 'Compra sem pontos' || (item.type === 'Ajuste' && !item.points)">
                  <span class="points-value points-neutral">0</span>
                  <span class="points-label">PONTOS</span>
                </div>
                <template v-else-if="item.type !== 'Vale-troca ativado' && item.type !== 'Vale-troca cancelado' && item.points">
                  <span class="points-value" :class="getPointsColorClass(item)">{{ item.points }}</span>
                  <span class="points-label">PONTOS</span>
                </template>
                <div v-else-if="shouldShowVoucherIcon(item.type)">
                  <img :src="getVoucherIconSrc(item.type)" :alt="item.type" class="voucher-icon" />
                </div>
                <div v-else>
                  <span class="points-value points-neutral">0</span>
                  <span class="points-label">PONTOS</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-if="history.length > 0" class="pagination-container">
        <v-pagination
          :value="currentPage"
          class="justify-end"
          :length="totalPages"
          :total-visible="4"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          @input="handlePageChange"
        />
      </div>

      <span v-else class="texto-corrido bold"> Não há histórico de compras e utilização de vales-troca para esse consumidor no período selecionado. </span>
    </div>
  </div>
</template>

<script>
import FiltersMenu from '@/components/FiltersMenu.vue'

const weekDays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB']

export default {
  name: 'ExtractHistoryTable',
  components: {
    FiltersMenu,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    initialDate: {
      type: String,
      default: null,
    },
    finalDate: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemsPerPage: 10,
    }
  },
  mounted() {
    this.$bus.$on('filter', this.handleFilterChange)
  },
  beforeDestroy() {
    this.$bus.$off('filter', this.handleFilterChange)
  },
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page)
    },
    handleFilterChange() {
      const stateFilters = this.$store.state.filters
      const stateUnits = this.$store.state.filters.units

      let initialDate = null
      let finalDate = null
      let units = null

      if (stateFilters.data && stateFilters.data.length === 2) {
        ;[initialDate, finalDate] = stateFilters.data
      }

      if (stateUnits && stateUnits.length > 0) {
        units = stateUnits
      }

      this.$emit('filter-change', { initialDate, finalDate, units })
    },
    getBackgroundClass(type, item) {
      switch (type) {
        case 'Compra':
          return 'bg-green'
        case 'Vale-troca expirado':
        case 'Pontos expirados':
          return 'bg-red'
        case 'Vale-troca ativado':
          return 'bg-blue'
        case 'Ajuste':
          if (item.points) {
            const pointsValue = typeof item.points === 'string' ? item.points.replace(/\s/g, '') : item.points
            if (pointsValue && pointsValue.startsWith('+')) {
              return 'bg-green'
            } else if (pointsValue && pointsValue.startsWith('-')) {
              return 'bg-red'
            }
          }
          return 'bg-default'
        case 'Vale-troca utilizado':
          return 'bg-blue'
        case 'Vale-troca cancelado':
          return 'bg-red'
        default:
          return 'bg-default'
      }
    },
    shouldShowVoucherIcon(type) {
      return type === 'Vale-troca ativado' || type === 'Vale-troca cancelado'
    },
    getVoucherIconSrc(type) {
      if (type === 'Vale-troca ativado') {
        return require('@/assets/icons/voucher-used.svg')
      } else if (type === 'Vale-troca cancelado') {
        return require('@/assets/icons/voucher-expired.svg')
      }
      return ''
    },
    getPointsColorClass(item) {
      const type = item.type
      const value = typeof item.points === 'string' ? item.points.replace(/\s/g, '') : item.points

      if (type === 'Vale-troca utilizado') {
        return 'points-neutral'
      }

      if (value && value.startsWith('-')) {
        return 'points-negative'
      }
      if (value && value.startsWith('+')) {
        return 'points-positive'
      }
      return 'points-positive'
    },
    formatDate(dateStr, itemType = null) {
      let date = new Date(dateStr)

      if (itemType === 'Pontos expirados') {
        date = new Date(date.getTime() + 3 * 60 * 60 * 1000)
      }

      const weekDay = weekDays[date.getDay()]
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return {
        weekDay,
        date: `${day}.${month}`,
      }
    },
    formatTime(dateStr, itemType = null) {
      let date = new Date(dateStr)

      if (itemType === 'Pontos expirados') {
        date = new Date(date.getTime() + 3 * 60 * 60 * 1000)
      }

      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    },
    shouldShowYearMarker(item, index) {
      if (index === 0) {
        return true
      }
      let currentItemDate = new Date(item.date)
      let previousItemDate = new Date(this.history[index - 1].date)

      if (item.type === 'Pontos expirados') {
        currentItemDate = new Date(currentItemDate.getTime() + 3 * 60 * 60 * 1000)
      }
      if (this.history[index - 1].type === 'Pontos expirados') {
        previousItemDate = new Date(previousItemDate.getTime() + 3 * 60 * 60 * 1000)
      }

      return currentItemDate.getFullYear() !== previousItemDate.getFullYear()
    },
    getItemYear(dateStr, itemType = null) {
      let date = new Date(dateStr)

      if (itemType === 'Pontos expirados') {
        date = new Date(date.getTime() + 3 * 60 * 60 * 1000)
      }

      return date.getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.filters-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.extract-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.extract-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  width: 100%;
  height: 64px;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.1));
  border-radius: 4px;
  overflow: hidden;
}

.extract-left-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 40px;
  height: 64px;
  background: #fff;
  border-radius: 4px 0 0 4px;
  width: 60%;

  @media (max-width: 600px) {
    gap: 16px;
    width: 80%;
  }
}

.extract-date-section {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  padding: 14px 40px 14px 2px;
  gap: 24px;
  border-right: 0.5px solid #d3d3d3;

  @media (max-width: 600px) {
    padding: 8px 0;
  }
}

.date-text {
  min-width: 48px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 133%;
  text-align: center;
  color: #7b7b7b;
  white-space: nowrap;
  margin-top: 1px;
}

.date-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  @media (min-width: 600px) {
    display: block;
    min-width: 72px;
  }
}

.date-separator {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 133%;
  text-align: center;
  color: #7b7b7b;
  white-space: nowrap;
  margin-inline: 2px;
}

.time-text {
  min-width: 40px;
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 120%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #7b7b7b;
  white-space: nowrap;
}

.extract-description-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  gap: 6px;
  flex: 1 1 0;
  overflow: hidden;
}

.description-title {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 133%;
  color: #6b7580;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.description-subtitle {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 133%;
  color: $cinza-l30;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    font-weight: 400;
  }
}

.extract-right-section {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  height: 64px;
  border: 2px solid #ffffff;
  border-radius: 0 4px 4px 0;
  justify-content: center;
  background: #f0f0f0;
}

.bg-green {
  background: #f9fbf4 !important;
}
.bg-blue {
  background: #e9f2ff !important;
}
.bg-red {
  background: #ffede9 !important;
}
.bg-default {
  background: #f0f0f0 !important;
}

.points-container {
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
}

.points-value {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: #686868;
  white-space: nowrap;
}

.points-positive {
  color: #4a803c;
}

.points-negative {
  color: #d03111;
}

.points-neutral {
  color: #686868;
}

.points-label {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 133%;
  color: #686868;
  margin-left: 8px;
  margin-top: 4px;
  white-space: nowrap;

  @media (max-width: 600px) {
    margin: 0;
  }
}

.voucher-icon {
  width: 36px;
  height: 24px;
  display: block;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
}

.year-marker {
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  color: #000000;
  margin-bottom: 16px;
  width: 100%;
  text-align: left;
  padding: 8px 0;
}
</style>
